import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gitOpsWorkflowDestroy } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { Workflow } from '../types';
import { workflowQueryKeys } from '../../queries/query-keys';

async function destroyWorkflow(id: Workflow['id']): Promise<void> {
  await gitOpsWorkflowDestroy({ path: { id } });
}

export function useDestroyWorkflowMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: destroyWorkflow,
    onSuccess: (_, id) => {
      queryClient.removeQueries({ queryKey: workflowQueryKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: workflowQueryKeys.all });
    },
    ...withError('Unable to destroy workflow'),
  });
}
